import { state } from '@/store/userEditDetails/state';
import { actions } from '@/store/userEditDetails/actions';
import { mutations } from '@/store/userEditDetails/mutations';
import { getters } from '@/store/userEditDetails/getters';

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export { state, getters, mutations, actions };
